import React from 'react';

const DeckRefreshContext = React.createContext();
DeckRefreshContext.displayName = 'DeckRefreshContext';

export default DeckRefreshContext;